module.exports = __webpack_public_path__ + "img/tugrik-sign.a2302f13.svg";